import { render, staticRenderFns } from "./GameLatecomer.vue?vue&type=template&id=6d29a969&"
import script from "./GameLatecomer.vue?vue&type=script&lang=js&"
export * from "./GameLatecomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d29a969')) {
      api.createRecord('6d29a969', component.options)
    } else {
      api.reload('6d29a969', component.options)
    }
    module.hot.accept("./GameLatecomer.vue?vue&type=template&id=6d29a969&", function () {
      api.rerender('6d29a969', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game/GameLatecomer.vue"
export default component.exports